module.exports = "<p>\r\n  admin-util works!\r\n</p>"